PESAPP.sponsorIndex = (function(m, $) {
  m.options = {
    template: 'sponsor-index',
    sorts: 'field_logo_sponsor_level,title',
    ajax: {
      dataType: 'jsonp',
    },
  };

  m.levels = {};

  m.init = function() {
    var parent = this;
    var views = $(parent.view);

    views.each(function(i) {
      var self = PESAPP.extend(parent, {view: $(this)});
      var template = PESAPP.extend(PESAPP.template, self);
      var getData = PESAPP.extend(PESAPP.getData, self);
      promise = getData.getData();
      template.getTemplate();
      template.id = i;

      promise.on('dataReady', function(event, response) {
        template.data = _mapItems(self, response);
        template.updateTemplate();
      });
    });
  };

  function _mapItems(self, items) {
    var mapped = {
      levels: self.levels,
      items: [],
    };
    items = PESAPP.sort(items, self.options.sorts);

    $.each(items, function(i, item) {
      item.levelSlug = PESAPP.slugify(item.field_logo_sponsor_level);
      mapped.items.push(item);
    });

    $.each(mapped.levels, function(key, level) {
      level.slug = PESAPP.slugify(level.heading);
      level.number = key;
      level.items = [];

      $.each(mapped.items, function(i, item) {
        if (
          item.field_logo_sponsor_level === key ||
          item.levelSlug === key
        ) {
          level.items.push(item);
        }
      });
    });

    return mapped;
  }

  return m;

}(PESAPP.sponsorIndex || {}, jQuery));
